export default function SelectInput(props) {

  return (
    <select className="form__fields__input form__fields__select" name={props.name} id={props.label} required={props.required}>
      <option>{props.label}</option>
      {props.options.map((option, index) => <option key={index} value={option.value}>{option.label}</option>)}
    </select>
  );
}
